export default __webpack_public_path__ + "static/media/Solana (SOL)Light.26805ee7.svg";